import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import useStyles from './styles';
export default function Separator(_ref) {
  let _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.separatorContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.separatorText
  }, text), /*#__PURE__*/React.createElement("div", {
    className: classes.separatorLine
  }));
}
Separator.propTypes = {
  text: PropTypes.string
};